<div class="form-content">
  <div class="w-100 row">
    <div class="form-block col-12 col-lg-4">
      <app-form-field-text
        [field]="nameControl"
        label="label.name"
        [required]="true"
        [disabled]="!isEditMode"
      ></app-form-field-text>
      <app-form-field-select
        [field]="templateControl"
        [options]="templateOptions"
        label="label.test-template"
        [required]="true"
        [disabled]="!isEditMode"
      ></app-form-field-select>
    </div>

    <div class="form-block col-12 col-lg-4">
      <app-form-field-date
        [field]="validityStartControl"
        [required]="true"
        [disabled]="!isEditMode"
        label="label.validity-period-start"
      ></app-form-field-date>
      <app-form-field-date
        [field]="validityEndControl"
        [minDate]="earliestEndDate"
        [disabled]="!isEditMode"
        label="label.validity-period-end"
      ></app-form-field-date>
    </div>

    <div class="form-block col-12 col-lg-4">
      <app-form-field-text
        [field]="testReportPdfTemplateIdControl"
        label="label.pft-templates.report"
        [required]="false"
        [disabled]="!isEditMode"
      ></app-form-field-text>
      <app-form-field-text
        [field]="invitationPdfTemplateIdControl"
        label="label.pft-templates.invitation"
        [required]="false"
        [disabled]="!isEditMode"
      ></app-form-field-text>
    </div>
  </div>

  <div class="w-100">
    <h2 class="fs-3 fw-bold" [hidden]="isEditMode">{{ 'label.exams.exam-statistics' | translate }}</h2>
    <app-exam-event-statistics-table
      [searchFilters]="eventStatisticsSearchFilters"
      (eventChosen)="testEventSelected($event)"
      (eventsSelectedForMultiAction)="updateEventsSelectedForMultiAction($event)"
      [hidden]="isEditMode"
    ></app-exam-event-statistics-table>

    <div class="w-100 d-flex flex-wrap justify-content-center gap-2 align-items-center">
      <!-- Back, Cancel, and Delete buttons-->
      <button
        *ngIf="!isEditMode"
        [routerLink]="['/home/exam']"
        type="button"
        class="btn btn-primary d-flex align-items-center"
      >
        <i class="bi bi-caret-left-fill me-2"></i>
        {{ 'button.back' | translate }}
      </button>
      <button
        *ngIf="isEditMode"
        (click)="toggleEditMode()"
        type="button"
        class="btn btn-outline-primary d-flex align-items-center"
      >
        {{ 'button.cancel' | translate }}
      </button>
      <button
        (click)="delete()"
        type="button"
        class="btn btn-outline-danger d-flex align-items-center"
        *ngIf="isEditMode"
      >
        <i class="bi bi-trash-fill me-2"></i>
        {{ 'button.delete' | translate }}
      </button>

      <!-- Up- and Download buttons -->
      <button
        (click)="downloadRegistrations()"
        type="button"
        class="btn btn-primary d-flex align-items-center"
        *ngIf="!isEditMode"
        [disabled]="areTestEventsSelected"
        attr.aria-label="{{ 'button.download.test-registrations-csv-full' | translate }}"
      >
        <i class="bi bi-download me-2" aria-hidden="true"></i>
        <span aria-hidden="true">
          {{ 'button.download.test-registrations-csv' | translate }}
        </span>
      </button>
      <button
        (click)="downloadStatistics()"
        type="button"
        class="btn btn-primary d-flex align-items-center"
        *ngIf="!isEditMode"
        [disabled]="areTestEventsSelected"
        attr.aria-label="{{ 'button.download.test-event-statistics-csv-full' | translate }}"
      >
        <i class="bi bi-download me-2" aria-hidden="true"></i>
        <span aria-hidden="true">
          {{ 'button.download.test-event-statistics-csv' | translate }}
        </span>
      </button>

      <div *ngIf="!isEditMode" class="btn-group" dropdown [dropup]="true">
        <button
          id="button-dropup-invitations" 
          dropdownToggle 
          type="button" 
          class="btn btn-primary dropdown-toggle d-flex align-items-center" 
          attr.aria-label="{{ 'button.invitations.menu-full' | translate }}"
        >
          {{ 'button.invitations.menu' | translate }}
        </button>
        <ul id="dropdown-dropup-invitations" *dropdownMenu class="dropdown-menu" aria-labelledby="button-dropup-invitations">
          <li class="w-100">
            <ngx-file-drop
              class="invitation-file-upload"
              (onFileDrop)="uploadTestInvitationData($event)"
              [directory]="false"
              dropZoneClassName="file-upload-drop-zone"
              contentClassName="file-upload-content"
              [multiple]="false"
              accept=".csv,.ssv"
            >
              <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <button
                  type="button"
                  (click)="openFileSelector()"
                  class="dropdown-item d-flex align-items-center"
                  [disabled]="currentlyUploadingInvitationData"
                  attr.aria-label="{{ 'button.invitations.upload-full' | translate }}"
                >
                  <i class="bi bi-upload me-2" aria-hidden="true"></i>
                  <span aria-hidden="true">
                    {{ 'button.invitations.upload' | translate }}
                  </span>
                </button>
              </ng-template>
            </ngx-file-drop>
          </li>
          <li class="w-100">
            <button
              type="button"
              (click)="sendInvitationsForSelectedEvents()"
              class="dropdown-item d-flex align-items-center"
              [disabled]="isSendBookingsDisabled"
              attr.aria-label="{{ 'button.invitations.send-selected' | translate }}"
            >
              <i class="bi bi-envelope-arrow-down-fill me-2" aria-hidden="true"></i>
              <span aria-hidden="true">
                {{ 'button.invitations.send-selected' | translate }}
              </span>
            </button>
          </li>
        </ul>
      </div>

      <div *ngIf="!isEditMode" class="btn-group" dropdown [dropup]="true">
        <button 
          id="button-dropup-results" 
          dropdownToggle 
          type="button" 
          class="btn btn-primary dropdown-toggle d-flex align-items-center" 
          attr.aria-label="{{ 'button.test-results.menu-full' | translate }}"
        >
          {{ 'button.test-results.menu' | translate }}
        </button>
        <ul id="dropdown-dropup-results" *dropdownMenu class="dropdown-menu" aria-labelledby="button-dropup-results">
          <li class="w-100">
            <ngx-file-drop
              class="invitation-file-upload"
              (onFileDrop)="uploadTestResults($event)"
              [directory]="false"
              dropZoneClassName="file-upload-drop-zone"
              contentClassName="file-upload-content"
              [multiple]="false"
              accept=".csv,.ssv"
            >
              <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <button
                  type="button"
                  (click)="openFileSelector()"
                  class="dropdown-item d-flex align-items-center"
                  [disabled]="currentlyUploadingResults"
                  attr.aria-label="{{ 'button.test-results.upload-full' | translate }}"
                >
                  <i class="bi bi-upload me-2" aria-hidden="true"></i>
                  <span aria-hidden="true">
                    {{ 'button.test-results.upload' | translate }}
                  </span>
                </button>
              </ng-template>
            </ngx-file-drop>
          </li>
          <li class="w-100">
            <button
              type="button"
              (click)="downloadTestResults()"
              class="dropdown-item d-flex align-items-center"
              [disabled]="areTestEventsSelected"
              attr.aria-label="{{ 'button.test-results.download-full' | translate }}"
            >
              <i class="bi bi-download me-2" aria-hidden="true"></i>
              <span aria-hidden="true">
                {{ 'button.test-results.download' | translate }}
              </span>
            </button>
          </li>
          <li class="w-100">
            <button
              type="button"
              (click)="generateAndSendOutReports()"
              class="dropdown-item d-flex align-items-center"
              [disabled]="areTestEventsSelected"
              attr.aria-label="{{ 'button.test-results.generate-pdfs-full' | translate }}"
            >
              <i class="bi bi-envelope-arrow-down-fill me-2" aria-hidden="true"></i>
              <span aria-hidden="true">
                {{ 'button.test-results.generate-pdfs' | translate }}
              </span>
            </button>
          </li>
        </ul>
      </div>

      <!-- Edit / Save buttons -->
      <button
        (click)="toggleEditMode()"
        type="button"
        class="btn btn-warning d-flex align-items-center"
        *ngIf="!isEditMode"
      >
        <i class="bi bi-pencil-fill me-2"></i>
        {{ 'button.edit' | translate }}
      </button>
      <button
        (click)="submit()"
        type="button"
        class="btn btn-primary d-flex align-items-center"
        *ngIf="isEditMode"
      >
        <i class="bi bi-floppy-fill me-2"></i>
        {{ 'button.save' | translate }}
      </button>
    </div>

    <!-- <h2 class="fs-3 fw-bold">{{ 'label.exams.exam-events' | translate }}</h2>
    TODO: Hier kommt eine Liste der Testevents rein. -->
  </div>
</div>
